import React from 'react';
import Product from './Product';
import {Container, Row, Col} from 'react-bootstrap';


const Products = ({products, onAddToCart}) => {
  return (
    <Container>
      <h2 className='mt-4'>Our Products</h2>
        <Row>
          
           {products.map(product => (
            <Col key={product.id} xs={12} sm={6} md={4} lg={3} className='pt-3'>
              <Product product={product} onAddToCart={onAddToCart}/>
            </Col>
          ))}  
        </Row>
    </Container>
  )
}

export default Products;
